import React from 'react';
import {Helmet} from 'react-helmet-async';

const SEO = ({
                 title,
                 description,
                 keywords,
                 canonical,
                 ogImage = "https://www.thesealab.com/sealab_icon.png",
                 schemaMarkup
             }) => {
    const defaultTitle = "The Sealab – Premium Kitchen Cabinets";
    const defaultDescription = "Shop high-quality kitchen cabinets, pantry cabinets, RTA cabinets, and cabinet hardware at The Sealab. Premium ready-to-assemble cabinets for your kitchen remodel.";
    const defaultKeywords = "kitchen cabinets, pantry cabinets, RTA cabinets, ready to assemble cabinets, cabinet hardware, kitchen remodeling, shaker cabinets, cabinet doors, kitchen renovation, cabinet accessories";

    const fullTitle = title ? `${title} | The Sealab` : defaultTitle;
    const metaDescription = description || defaultDescription;
    const metaKeywords = keywords || defaultKeywords;

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription}/>
            <meta name="keywords" content={metaKeywords}/>

            {/* Canonical URL */}
            {canonical && <link rel="canonical" href={canonical}/>}

            {/* Open Graph Tags */}
            <meta property="og:title" content={fullTitle}/>
            <meta property="og:description" content={metaDescription}/>
            <meta property="og:type" content="website"/>
            <meta property="og:url" content={canonical || "https://www.thesealab.com"}/>
            <meta property="og:image" content={ogImage}/>
            <meta property="og:site_name" content="The Sealab"/>

            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content={fullTitle}/>
            <meta name="twitter:description" content={metaDescription}/>
            <meta name="twitter:image" content={ogImage}/>

            {/* Additional E-commerce Tags */}
            <meta name="robots" content="index, follow"/>
            <meta name="author" content="The Sealab"/>
            <meta name="viewport" content="width=device-width, initial-scale=1"/>

            {/* Schema.org Markup */}
            {schemaMarkup && (
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;